/**
 * Not only requires a location to be set, but the location must be accepting orders as well
 */

import store from "@/store/store";

export default async (to, from, next) => {
  if (
    store.state.order.location &&
    store.state.order.location.acceptingOrders
  ) {
    return next();
  }

  return next("/");
};
